unable to read source [project]/node_modules/@zxing/src/common/IScannerControls.ts